import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class TagOnceSettingsManager extends AbstractTagClass {
    #onceSettings = {};
    constructor(argument) {
        super({
            ...argument,
            name: 'TagOnceSettingsManager'
        });
    }
    get onceSettings() {
        return this.#onceSettings;
    }
    set onceSettings(settings) {
        this.#onceSettings = settings;
    }
    getOnceSettings(key = undefined) {
        if (this.utils.Type.isEmpty(key) || !this.utils.Type.isString(key)) {
            return undefined;
        }
        const value = this?.onceSettings?.[key];
        delete this?.onceSettings?.[key];
        return value;
    }
}
